import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  toggleFilters: true,
  allInventory: null,
  paginatedInventory: null,
  allTransactions: null,
  paginatedTransactions: null,
  allOrders: null,
  paginatedOrders: null,
  selectedReports: {
    inventory: false,
    transactions: false,
    reports: false,
    lowStock: false,
  },
  reportData: {
    inventory: [],
    transactions: [],
    reports: [],
    lowStock: [],
  },
  isLoading: false,
  activeTab: '1',
  error: [],
  inventoryFilters: {},
  transactionFilters: {},
  orderFilters: {},
  dashboardCounts: null,
  dashboardTurnover: null,
};

const inventorySlice = createSlice({
  name: 'inventory',
  initialState,
  reducers: {
    setReducerError: (state, action) => {
      state.error = action.payload;
    },
    setAllInventory: (state, action) => {
      state.allInventory = action.payload;
      state.error = [];
    },
    setPaginatedInventory: (state, action) => {
      state.paginatedInventory = action.payload;
      state.error = [];
    },
    setAllTransactions: (state, action) => {
      state.allTransactions = action.payload;
      state.error = [];
    },
    setPaginatedTransactions: (state, action) => {
      state.paginatedTransactions = action.payload;
      state.error = [];
    },
    setAllOrders: (state, action) => {
      state.allOrders = action.payload;
      state.error = [];
    },
    setPaginatedOrders: (state, action) => {
      state.paginatedOrders = action.payload;
      state.error = [];
    },
    setResetInventory: () => {
      return initialState;
    },
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    addToReportData: (state, action) => {
      const { type, data } = action.payload;
      state.selectedReports[type] = true;
      state.reportData[type] = data;
    },
    removeFromReportData: (state, action) => {
      const { type } = action.payload;
      state.selectedReports[type] = false;
      state.reportData[type] = [];
    },
    resetReportData: (state) => {
      state.selectedReports = {
        inventory: false,
        transactions: false,
        reports: false,
        lowStock: false,
      };
      state.reportData = {
        inventory: [],
        transactions: [],
        reports: [],
        lowStock: [],
      };
    },
    setToggleFilters: (state, action) => {
      state.toggleFilters = !state.toggleFilters;
    },
    setToggleFiltersTrue: (state, action) => {
      state.toggleFilters = true;
    },
    setToggleFiltersFalse: (state, action) => {
      state.toggleFilters = false;
    },
    setInventoryFilters: (state, action) => {
      state.inventoryFilters = action.payload;
    },
    setTransactionFilters: (state, action) => {
      state.transactionFilters = action.payload;
    },
    setOrderFilters: (state, action) => {
      state.orderFilters = action.payload;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setDashboardCounts: (state, action) => {
      state.dashboardCounts = action.payload;
    },
    setDashboardTurnover: (state, action) => {
      state.dashboardTurnover = action.payload;
    },
  },
});

export const {
  setReducerError,
  setAllInventory,
  setPaginatedInventory,
  setAllTransactions,
  setPaginatedTransactions,
  setAllOrders,
  setPaginatedOrders,
  setResetInventory,
  setActiveTab,
  addToReportData,
  removeFromReportData,
  resetReportData,
  setToggleFilters,
  setToggleFiltersTrue,
  setToggleFiltersFalse,
  setInventoryFilters,
  setTransactionFilters,
  setOrderFilters,
  setIsLoading,
  setDashboardCounts,
  setDashboardTurnover,
} = inventorySlice.actions;

export default inventorySlice.reducer;
